import {
  ChangeDetectionStrategy,
  Component,
  computed,
  signal,
} from '@angular/core';
import { CasesService } from '../services/cases.service';
import { SessionService } from '@core/services/session.service';
import { CasesCaseComponent } from '../cases-case/cases-case.component';
import { SearchInputComponent } from '../../../core/components/search-input/search-input.component';
import { SelectComponent } from '../../../core/components/select/select.component';
import { casesListAnimation } from '@core/utils/animations.util';

enum SortOptions {
  highest_price,
  lowest_price,
}

interface SortOption {
  label: string;
  key: keyof typeof SortOptions;
  fn: () => void;
}

@Component({
  selector: 'app-cases-list',
  templateUrl: './cases-list.component.html',
  styleUrls: ['./cases-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CasesCaseComponent, SearchInputComponent, SelectComponent],
  animations: [casesListAnimation],
  host: {
    class: 'container-xl',
  }
})
export class CasesListComponent {
  readonly search = signal<string>('');

  filtered = computed(() => {
    return this.casesService
      .casesList()
      .filter((items) =>
        items.name.toLowerCase().includes(this.search().toLowerCase())
      )
      .sort((a, b) => {
        return this.sort().key === 'highest_price'
          ? b.price - a.price
          : a.price - b.price;
      });
  });

  readonly sortOptions: SortOption[] = [
    {
      label: 'Highest Price',
      key: 'highest_price',
      fn: () => {
        this.sort.set(this.sortOptions[0]);
      },
    },
    {
      label: 'Lowest Price',
      key: 'lowest_price',
      fn: () => {
        this.sort.set(this.sortOptions[1]);
      },
    },
  ];
  readonly sort = signal<SortOption>(this.sortOptions[0]);

  constructor(
    public casesService: CasesService,
    public sessionService: SessionService
  ) {}
}
